import { render, staticRenderFns } from "./ListTask.vue?vue&type=template&id=04202129&"
import script from "./ListTask.vue?vue&type=script&lang=js&"
export * from "./ListTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports